import { IMDSDialogProps } from "@/mds/components/overlays/dialog/dialog.types";
import { MDSDialog } from "@/mds/components/overlays/dialog/dialog";
import { MDSModal } from "@/mds/components/overlays/modal/modal";
import { IMDSModalProps } from "@/mds/components/overlays/modal/modal.types";

export const MDSModalDialog = ({ ...props }: IMDSDialogProps & IMDSModalProps) => {
  return (
    <MDSModal {...props} data-mds-name="modal-dialog">
      <MDSDialog {...props} />
    </MDSModal>
  );
};
